import axios from 'axios';
import FormData from 'form-data';

import LocalStorageService from './localStorageService';


import { API_HOST } from '../config/api';
import { getAuthToken } from './auth';

// Order-related functions
export const orderGetStatus = async (id) => {
    const response = await GET('/sheffmed-order/' + id);
    console.log("response", response);
    return response?.data || {};
};

export const orderCreate = async (products, addressId, paymentType, expectedPricePence) => {
    console.log("SENDING orderCreate", products, addressId, paymentType, expectedPricePence);
    const response = await POST('/sheffmed-order', {
        products,
        addressId,
        paymentType,
        expectedPricePence
    });
    console.log("orderCreate response", response);
    return response || {};
};

export const orderOptions = async (priceInPence, location) => {
    console.log("SENDING orderOptions", priceInPence, location);
    const response = await POST('/sheffmed-order/shipping', {
        location,
        orderValuePence: priceInPence
    });
    console.log("orderOptions response", response);
    return response?.data || {};
};

export const orderGet = async () => {
    const response = await GET('/sheffmed-order/all');
    console.log("response", response);
    return response?.data || {};
};


// Address-related functions
export const contentGet = async () => {
    const response = await GET('/sheffmed-content');
    console.log("response", response);
    return response?.data || [];
};

export const contentUpdate = async (id, body) => {
    const response = await PATCH('/sheffmed-content/' + id, body);
    return response?.data || {};
};

export const contentCreate = async (body) => {
    const response = await POST('/sheffmed-content', body);
    return response?.data || {};
};

export const contentDelete = async (id) => {
    const response = await DELETE('/sheffmed-content/' + id);
    console.log("response", response);
    return response?.data || {};
};

// Address-related functions
export const addressGet = async () => {
    const response = await GET('/sheffmed-address');
    console.log("response", response);
    return response?.data || [];
};

export const addressUpdate = async (id, body) => {
    const response = await PUT('/sheffmed-address/' + id, body);
    return response?.data || {};
};

export const addressCreate = async (body) => {
    const response = await POST('/sheffmed-address', body);
    return response?.data || {};
};

export const addressDelete = async (id) => {
    const response = await DELETE('/sheffmed-address/' + id);
    console.log("response", response);
    return response?.data || {};
};

// Profile-related functions
export const profileGet = async () => {
    const response = await GET('/sheffmed-user');
    console.log("response", response);
    return response?.data || {};
};

export const userList = async (role = 'User') => {
    const response = await GET('/sheffmed-user/list?role='+role);
    console.log("response", response);
    return response?.data || {};
};

export const profileUpdate = async (body) => {
    const response = await PUT('/sheffmed-user', body);
    return response;
};

// Product-related functions
export const productGet = async () => {
    const response = await GET('/sheffmed/product').catch(console.error);
    return response?.products || [];
};

// User related functions

export const userUpdate = async (id, body) => {
    const response = await PUT('/sheffmed-user/' + id, body);
    return response?.data || {};
};

export const userCreate = async (body) => {
    console.log("SENDING userCreate", body);
    const response = await POST('/sheffmed-user', body);
    return response?.data || {};
};

export const uploadFile = async (filename, mimeType, imageData, isPublic = true) => {
    let body = {
        filename: filename,
        mimeType: mimeType,
        data: imageData,
        isPublic: isPublic
    }
    const response = await POST('/sheffmed/upload', body);
    return response || {};
}


// Generic HTTP methods

export const GET = async (url) => {
    const token = await getAuthToken();
    console.log("token", token);

    const myHeaders = new Headers();
    if (token) myHeaders.append("token", token);
    myHeaders.append("Content-Type", 'application/json');

    const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow"
    };

    const response = await fetch(API_HOST + url, requestOptions);
    return await response.json();
};

export const POST = async (url, body) => {
    const token = await getAuthToken();

    const myHeaders = new Headers();
    if (token) myHeaders.append("token", token);
    myHeaders.append("Content-Type", 'application/json');

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(body),
        redirect: "follow"
    };

    const response = await fetch(API_HOST + url, requestOptions);
    return await response.json();
};

export const PUT = async (url, body) => {
    const token = await getAuthToken();

    const myHeaders = new Headers();
    if (token) myHeaders.append("token", token);
    myHeaders.append("Content-Type", 'application/json');

    const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: JSON.stringify(body),
        redirect: "follow"
    };

    const response = await fetch(API_HOST + url, requestOptions);
    return await response.json();
};

export const PATCH = async (url, body) => {
    const token = await getAuthToken();

    const myHeaders = new Headers();
    if (token) myHeaders.append("token", token);
    myHeaders.append("Content-Type", 'application/json');

    const requestOptions = {
        method: "PATCH",
        headers: myHeaders,
        body: JSON.stringify(body),
        redirect: "follow"
    };

    const response = await fetch(API_HOST + url, requestOptions);
    return await response.json();
};

export const DELETE = async (url) => {
    const token = await getAuthToken();

    const myHeaders = new Headers();
    if (token) myHeaders.append("token", token);
    myHeaders.append("Content-Type", 'application/json');

    const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow"
    };

    const response = await fetch(API_HOST + url, requestOptions);
    return await response.json();
};